import { sendPhoneCode as sendPhoneCodeRequest } from "@vetty/api-sdk";
import { axiosInstance } from "@/helpers";

const sendPhoneCode = async (phone: string) => {
  try {
    const { data } = await sendPhoneCodeRequest(axiosInstance, {
      phone: phone,
    });

    console.log(data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export { sendPhoneCode };
